var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"4668dd741b2c4ae372fed461aecdd7c487c69740"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";
import { BrowserTracing } from "@sentry/tracing";

import { SENTRY_ENV } from "./constants";

// Sentry
if (SENTRY_ENV !== "local") {
  Sentry.init({
    // sentry docs recommend direct dsn inclusion
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: "frontend-" + SENTRY_ENV,

    integrations: [
      new BrowserTracing({
        traceFetch: true,
        tracePropagationTargets: [
          /(dev-)*(staging-)*api\.capturesales\.com.au/,
        ],
      }),
    ],

    // traces capture rate, recommend lower for production
    tracesSampleRate: 1.0,

    // replay capture rate
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps

    // globally set issue_source tag
    beforeSend(event) {
      event.tags = {
        ...event.tags,
        issue_source: "frontend",
      };
      return event;
    },
  });
} else {
  console.log("Sentry disabled for local development");
}
